module.exports = __webpack_public_path__ + "img/lakkozasi-eljarasok.fd691c3c.jpg";